import { useCallback } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';

import { ReadonlyDocumentScoresStore, useReadonlyDocumentScoresActions } from '../store';

const useStoreState = createStateSelectorHook(ReadonlyDocumentScoresStore, [
  'detailsPanelVisibleForInstanceId',
]);

/** For the host: whether the details panel is open, and a way to close it. */
export const useDetailsPanel = () => {
  const { detailsPanelVisibleForInstanceId } = useStoreState();
  const actions = useReadonlyDocumentScoresActions();

  const closeDetails = useCallback(() => actions.closeVariationDetailsPanel(), [actions]);

  return { detailsOpen: detailsPanelVisibleForInstanceId !== null, closeDetails };
};
